import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultScheduleService } from 'app/core/services/default-schedule.service';
import { RefreshDefaultschedulelineService } from 'app/core/services/refresh-defaultscheduleline/refresh-defaultscheduleline.service';

@Component({
  selector: 'dialog-delete-defaultschedule-batch',
  templateUrl: './dialog-delete-defaultschedule-batch.component.html',
  styleUrls: ['./dialog-delete-defaultschedule-batch.component.scss']
})
export class DialogDeleteDefaultscheduleBatchComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteDefaultscheduleBatchComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
    private defaultScheduleService: DefaultScheduleService, private refreshDefaultschedulelineService: RefreshDefaultschedulelineService) { }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSelectedElement() {
    this.isLoading = true;
    this.defaultScheduleService.deleteScheduleLine(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refreshDefaultschedulelineService.emitRefresh(this.data.selectedIds);
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting element:', err);
        alert('Failed to delete selected element.');
      },
    });
  }
}
